import api from './config';

export const personalActionsAPI = {
  // Obtener todas las acciones
  getAll: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.tipo) params.append('tipo', filters.tipo);
    if (filters.estado) params.append('estado', filters.estado);
    if (filters.employeeId) params.append('employeeId', filters.employeeId);
    if (filters.desde) params.append('desde', filters.desde);
    if (filters.hasta) params.append('hasta', filters.hasta);

    const response = await api.get(`/personal-actions?${params.toString()}`);
    return response.data;
  },

  // Obtener una acción por ID
  getById: async (id) => {
    const response = await api.get(`/personal-actions/${id}`);
    return response.data;
  },

  // Obtener historial de un empleado
  getEmployeeHistory: async (employeeId) => {
    const response = await api.get(`/personal-actions/employee/${employeeId}`);
    return response.data;
  },

  // Crear nueva acción
  create: async (actionData) => {
    const formData = new FormData();

    Object.keys(actionData).forEach(key => {
      if (actionData[key] !== null && actionData[key] !== undefined) {
        if (key === 'documento' && actionData[key] instanceof File) {
          formData.append('documento', actionData[key]);
        } else if (key === 'datos_accion') {
          formData.append('datos_accion', JSON.stringify(actionData[key]));
        } else {
          formData.append(key, actionData[key]);
        }
      }
    });

    const response = await api.post('/personal-actions', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Actualizar acción
  update: async (id, actionData) => {
    const formData = new FormData();

    Object.keys(actionData).forEach(key => {
      if (actionData[key] !== null && actionData[key] !== undefined) {
        if (key === 'documento' && actionData[key] instanceof File) {
          formData.append('documento', actionData[key]);
        } else if (key === 'datos_accion') {
          formData.append('datos_accion', JSON.stringify(actionData[key]));
        } else {
          formData.append(key, actionData[key]);
        }
      }
    });

    const response = await api.put(`/personal-actions/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Revocar acción
  delete: async (id, motivo) => {
    const response = await api.delete(`/personal-actions/${id}`, {
      data: { motivo }
    });
    return response.data;
  },

  // Aprobar acción
  approve: async (id) => {
    const response = await api.post(`/personal-actions/${id}/approve`);
    return response.data;
  },

  // Rechazar acción
  reject: async (id, motivo) => {
    const response = await api.post(`/personal-actions/${id}/reject`, { motivo });
    return response.data;
  },

  // Obtener estadísticas
  getStats: async () => {
    const response = await api.get('/personal-actions/stats/summary');
    return response.data;
  },

  // Obtener tipos de acciones
  getTipos: async () => {
    const response = await api.get('/personal-actions/tipos');
    return response.data;
  }
};
